import { Link } from "react-router-dom";
import "./loan-sections.css";

const DOCS = [
  {
    icon: "fa-id-card",
    title: "Identity Proof",
    text: "(Aadhaar, PAN, Passport, etc.)",
  },
  {
    icon: "fa-map-location-dot",
    title: "Address Proof",
    text: "(Utility Bill, Aadhaar, Passport, etc.)",
  },
  {
    icon: "fa-file-invoice-dollar",
    title: "Income Proof",
    text: "(Salary Slips, ITR, Bank Statements)",
  },
  {
    icon: "fa-camera",
    title: "Photographs",
    text: "(Recent Passport Size Photo)",
  },
];

export default function LoanDocuments() {
  return (
    <section className="loan-docs">
      <div className="loan-docs-panel">
        <header className="loan-section-head">
          <p className="loan-eyebrow">DOCUMENTS YOU NEED</p>
          <h2>Simple Documents. Quick Approval.</h2>
        </header>

        <div className="loan-docs-grid">
          {DOCS.map((doc) => (
            <article key={doc.title} className="loan-doc-card">
              <span className="loan-doc-icon" aria-hidden="true">
                <i className={`fa-solid ${doc.icon}`} />
              </span>
              <div>
                <h3>{doc.title}</h3>
                <p>{doc.text}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="loan-docs-action">
          <Link to="/contact" className="loan-docs-btn">
            Check Full Document List
            <span aria-hidden="true">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
